import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M61.21 14.15C61.31 7.10002 59.33 4.34996 53.5 1.70996H4.18003L2.62003 11.0699C2.62003 11.0699 0.95003 15.47 1.89003 18.89C2.83003 22.3 9.19003 26.27 5.12003 30.23C5.12003 30.23 9.85003 33.72 13.98 29.24H46.72L48.28 24.84C48.28 24.84 52.66 26.16 51.93 32.33C51.93 32.33 59.54 30.9 59.44 20.88C59.44 20.88 61.73 25.28 66.01 22.2C66.01 22.19 61.11 21.2 61.21 14.15Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
